import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";
import { forwardRef, ReactNode } from "react";
import VLPopover from "../../VLPopover";
import { ButtonType } from "antd/es/button/buttonHelpers";

type VLButtonPropsBase = Omit<ButtonProps, "type"> & {
  tooltip?: ReactNode;
  text?: string;
};

export type VLPrimaryButtonProps = VLButtonPropsBase & {
  type: "primary";
  isGradient?: boolean;
};
export type VLNormalButtonProps = VLButtonPropsBase & {
  type: Exclude<ButtonType, "primary">;
};

export type VLButtonProps = VLNormalButtonProps | VLPrimaryButtonProps;

const VLButton = forwardRef<HTMLButtonElement, VLButtonProps>(
  ({ tooltip, className, size = "large", text, ...rest }, ref) => {
    // isGradient is VLButton's own prop: keep it off antd's Button, which passes unknown props to the DOM <button>
    const { isGradient, ...buttonProps } = rest as Omit<
      VLPrimaryButtonProps,
      "tooltip" | "className" | "size" | "text"
    >;
    const btnClassName = classNames(styles.vlButton, className, {
      [styles.gradient]: buttonProps.type === "primary" && isGradient,
    });
    return (
      <VLPopover content={tooltip}>
        <Button ref={ref} className={btnClassName} size={size} {...buttonProps}>
          {text || buttonProps.children}
        </Button>
      </VLPopover>
    );
  },
);

export default VLButton;
